module.exports = __webpack_public_path__ + "img/meeting_intro_1.0e6ac4b8.png";